<template>
  <div class="flex flex-col gap-4">
    <!-- Header -->
    <TextHeader class="flex items-center justify-between border-none !pb-0">
      Installaties
      <span class="text-base font-normal md:hidden">
        <ExportComponent
          v-if="$route.name === 'assets-analysis'"
          small
          :metering-point="filterStore.currentMeteringPoint"
          :date-range="filterStore.dateRange"
          :type="EXPORT_TYPES.MEASUREMENTS"
        />
      </span>
    </TextHeader>
    <TabsComponent :tabs />
    <ToolbarComponent
      no-allocation-points
      uncollapsed
      no-mode
      :no-datepicker="$route.name !== 'assets-analysis'"
    >
      <div class="ml-auto">
        <ExportComponent
          v-if="$route.name === 'assets-analysis' && mdAndLarger"
          :metering-point="filterStore.currentMeteringPoint"
          :date-range="filterStore.dateRange"
          :type="EXPORT_TYPES.MEASUREMENTS"
        />
      </div>
    </ToolbarComponent>
    <MessageComponent
      v-if="filterStore.currentMeteringPoint?.demo"
      color="info"
    >
      {{ $p("demo-disclaimer") }}
    </MessageComponent>
    <RouterView />
  </div>
</template>

<script setup>
import { watch } from "vue"
import { startOfToday } from "date-fns"
import { breakpointsTailwind, useBreakpoints } from "@vueuse/core"
import $p from "@/services/phraseService.js"
import { ASSET } from "@/stores/repower/meteringPointStoreFactories.js"
import { EXPORT_TYPES } from "@/stores/repower/exportsStore.js"
import useFilterStore from "@/stores/filterStore.js"
import { TextHeader } from "@repowerednl/ui-component-library"
import TabsComponent from "@/components/navigation/TabsComponent.vue"
import ToolbarComponent from "@/components/navigation/ToolbarComponent.vue"
import ExportComponent from "@/components/information/ExportComponent.vue"
import MessageComponent from "@/components/information/MessageComponent.vue"
import useDefaultDateRange from "@/composables/useDefaultDateRange.js"

const filterStore = useFilterStore()
const breakpoints = useBreakpoints(breakpointsTailwind)
const mdAndLarger = breakpoints.greaterOrEqual("md")

useDefaultDateRange([startOfToday(), startOfToday()])

const tabs = [
  {
    name: "Meetgegevens",
    route: "assets-analysis",
  },
  {
    name: "Info",
    route: "assets-information",
  },
]

watch(
  () => filterStore.currentMeteringPoint,
  (currentMeteringPoint) => {
    if (currentMeteringPoint?.role !== ASSET) {
      filterStore.clearMeteringPoint()
    }
  },
  { immediate: true },
)
</script>
